import { http } from '@/lib/http';

export type UploadScope = 'org-logos' | 'warehouse-photos' | 'avatars';

export interface UploadedImage {
  url: string;
  key: string;
  size: number;
}

/**
 * M-orgprofile — POST a multipart image (logo / photo / avatar) to the
 * BE upload endpoint. Returns the persistable URL.
 *
 * The BE enforces a 5 MB cap and a PNG/JPEG/WebP/SVG content-type
 * allowlist; this helper does not pre-validate so the error surface
 * matches the BE response 1:1 (toast handlers consume the message).
 */
export const uploadsService = {
  uploadImage(args: {
    file: File;
    scope: UploadScope;
    ownerId?: string;
  }): Promise<UploadedImage> {
    const fd = new FormData();
    fd.append('file', args.file);
    fd.append('scope', args.scope);
    if (args.ownerId) fd.append('ownerId', args.ownerId);
    return http.post<UploadedImage, FormData>('/api/v1/platform/uploads/image', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
